import { MessageCircle } from "lucide-react";

const WA_URL =
  "https://wa.me/905392196017?text=Merhaba%20Konya%20%C3%87ekicim,%20yolda%20kald%C4%B1m.%20Konum%20payla%C5%9Fmak%20istiyorum.";

export default function WhatsAppFloat() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="hidden lg:flex fixed bottom-6 right-6 z-50 items-center gap-3 group"
      aria-label="WhatsApp ile yazın"
    >
      <span className="rounded-full bg-night-800/90 border border-white/15 px-4 py-2 text-sm text-slate-200 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
        Adem Usta çevrimiçi
        <span className="block text-[10px] uppercase tracking-widest text-wa">Genelde 1 dk içinde döner</span>
      </span>
      <span className="w-14 h-14 rounded-full bg-wa text-night-900 flex items-center justify-center animate-pulse-ring-green shadow-[0_0_24px_rgba(34,197,94,0.4)] transition-transform duration-200 group-hover:scale-110">
        <MessageCircle className="w-7 h-7" strokeWidth={2.2} />
      </span>
    </a>
  );
}
